import documentTransformations from "./documentTransformations";
import { FormTransformations } from "../../../types/ProductService/ProductService";

const shortTimeWorkTransformations: FormTransformations = {
  dateFields: [
    { path: "petitioner.birthDate", type: "date" },
    { path: "contractTerminationReceivedDate", type: "date" },
  ],
  numberFields: [...documentTransformations.numberFields, "percentageWorkTime", "weeklyWorkingHours", "grossSalary"],
  timeFields: [...documentTransformations.timeFields],
  floatFields: [...documentTransformations.floatFields],
  ibanFields: [],
};
export default shortTimeWorkTransformations;
